import { c as _c } from "react/compiler-runtime";
import { DataFileInterface, FileSourceEnum } from '@systemeio/file-manager';
import { Checkbox, FormInput, FormInputNumber, cents, centsToUnits, unitsToCents } from '@systemeio/ui';
import { ProductVariantInterface, ProductVariantsErrorsInterface } from 'modules/products/types/product-variant-interface';
import { ImageUploaderWithPreviewImage } from 'shared/components/file-uploader/image-uploader-with-preview-image';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
import { twJoin, twMerge } from 'tailwind-merge';
interface VariantProps {
  allowStock?: boolean;
  variant: ProductVariantInterface;
  setVariants: React.Dispatch<React.SetStateAction<ProductVariantInterface[]>>;
  isDeleteAvailable: boolean | null;
  variantsImages: DataFileInterface[];
  errors: {
    sku: string;
    stock: string;
    price: string;
  };
  setErrors: React.Dispatch<React.SetStateAction<ProductVariantsErrorsInterface>>;
}
function Variant(t0) {
  const $ = _c(76);
  const {
    allowStock,
    variant,
    setVariants,
    isDeleteAvailable,
    errors,
    setErrors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isLG
  } = useMediaQuery();
  let t1;
  if ($[0] !== setErrors || $[1] !== setVariants || $[2] !== variant.id) {
    t1 = e => {
      setVariants(prev => prev.map(v => v.id === variant.id ? {
        ...v,
        sku: e.target.value
      } : v));
      setErrors(prev_0 => {
        const oldState = {
          ...prev_0
        };
        if (Object.keys(oldState).includes(variant.id)) {
          delete oldState[variant.id];
        }
        return oldState;
      });
    };
    $[0] = setErrors;
    $[1] = setVariants;
    $[2] = variant.id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleChangeVariantSkuValue = t1;
  let t2;
  if ($[4] !== setVariants || $[5] !== variant.id) {
    t2 = value => {
      setVariants(prev_1 => prev_1.map(v_0 => v_0.id === variant.id ? {
        ...v_0,
        price: cents(unitsToCents(value).toFixed(2))
      } : v_0));
    };
    $[4] = setVariants;
    $[5] = variant.id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleChangeVariantPriceValue = t2;
  let t3;
  if ($[7] !== setVariants || $[8] !== variant.id) {
    t3 = newStock => {
      setVariants(prev_2 => prev_2.map(v_1 => v_1.id === variant.id ? {
        ...v_1,
        stock: newStock
      } : v_1));
    };
    $[7] = setVariants;
    $[8] = variant.id;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleChangeVariantStock = t3;
  let t4;
  if ($[10] !== setVariants || $[11] !== variant.id) {
    t4 = function setVariantImage(image) {
      setVariants(prev_3 => prev_3.map(v_2 => v_2.id === variant.id ? {
        ...v_2,
        image
      } : v_2));
    };
    $[10] = setVariants;
    $[11] = variant.id;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const setVariantImage = t4;
  let t5;
  if ($[13] !== setVariants || $[14] !== variant.id) {
    t5 = value_0 => {
      setVariants(prev_4 => prev_4.map(v_3 => v_3.id === variant.id ? {
        ...v_3,
        selected: value_0
      } : v_3));
    };
    $[13] = setVariants;
    $[14] = variant.id;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const handleChangeVariantSelect = t5;
  let disabled = false;
  if (isDeleteAvailable !== null) {
    disabled = isDeleteAvailable ? variant.deleted ? true : false : variant.deleted ? false : true;
  }
  const hasStock = allowStock || (variant.stock ?? 0) > 0;
  const t6 = hasStock ? "grid-cols-[18px_56px_minmax(15%,30%)_minmax(10%,18%)_minmax(10%,18%)_minmax(10%,20%)] gap-2" : "grid-cols-[25px_70px_minmax(15%,45%)_minmax(10%,20%)_minmax(10%,20%)] gap-5";
  let t7;
  if ($[16] !== t6) {
    t7 = twMerge("grid items-center", t6);
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = variant.selected ?? false;
  let t9;
  if ($[18] !== disabled || $[19] !== handleChangeVariantSelect || $[20] !== t8) {
    t9 = <div><Checkbox onChange={handleChangeVariantSelect} value={t8} disabled={disabled} /></div>;
    $[18] = disabled;
    $[19] = handleChangeVariantSelect;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== setVariantImage) {
    t10 = () => setVariantImage(undefined);
    $[22] = setVariantImage;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== setVariantImage || $[25] !== t10 || $[26] !== variant.image) {
    t11 = <ImageUploaderWithPreviewImage labelImageUploader="" aspectRatio={1} previewClassName="w-[60px] h-[60px]" value={variant.image} source={FileSourceEnum.Product} onSelect={setVariantImage} onRemove={t10} />;
    $[24] = setVariantImage;
    $[25] = t10;
    $[26] = variant.image;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const t12 = `text-text-primary customScroll overflow-x-auto whitespace-nowrap text-xl ${variant.deleted && "line-through"}`;
  let t13;
  if ($[28] !== variant.productOptionValues) {
    t13 = variant.productOptionValues?.map(_temp).join("/");
    $[28] = variant.productOptionValues;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const t15 = variant.sku;
  let t16;
  if ($[33] !== t) {
    t16 = t("dashboard.products.sku_number.title");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const t17 = isLG && "w-full";
  let t18;
  if ($[35] !== t17) {
    t18 = twJoin(t17);
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== errors.sku || $[38] !== handleChangeVariantSkuValue || $[39] !== t16 || $[40] !== t18 || $[41] !== variant.deleted || $[42] !== variant.sku) {
    t19 = <div className="ml-auto self-start"><FormInput value={t15} placeholder={t16} onChange={handleChangeVariantSkuValue} maxLength={256} inputClassName={t18} disabled={variant.deleted} error={errors.sku} /></div>;
    $[37] = errors.sku;
    $[38] = handleChangeVariantSkuValue;
    $[39] = t16;
    $[40] = t18;
    $[41] = variant.deleted;
    $[42] = variant.sku;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  const t20 = isLG && "w-full";
  let t21;
  if ($[44] !== t20) {
    t21 = twJoin(t20);
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== variant.price) {
    t22 = variant?.price ? centsToUnits(variant.price) : 0;
    $[46] = variant.price;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t) {
    t23 = t("dashboard.products.variant_price.title");
    $[48] = t;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== errors.price || $[51] !== handleChangeVariantPriceValue || $[52] !== t21 || $[53] !== t22 || $[54] !== t23 || $[55] !== variant.deleted) {
    t24 = <div className="self-start"><FormInputNumber inputClassName={t21} value={t22} placeholder={t23} onChange={handleChangeVariantPriceValue} maxLength={256} disabled={variant.deleted} error={errors.price} /></div>;
    $[50] = errors.price;
    $[51] = handleChangeVariantPriceValue;
    $[52] = t21;
    $[53] = t22;
    $[54] = t23;
    $[55] = variant.deleted;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== allowStock || $[58] !== errors.stock || $[59] !== handleChangeVariantStock || $[60] !== hasStock || $[61] !== t || $[62] !== variant.deleted || $[63] !== variant.stock) {
    t25 = hasStock && <div className="self-start"><FormInputNumber value={variant?.stock || 0} placeholder={t("dashboard.products.variant_stock")} onChange={handleChangeVariantStock} maxLength={256} disabled={variant.deleted || !allowStock} error={errors.stock} type="integer" /></div>;
    $[57] = allowStock;
    $[58] = errors.stock;
    $[59] = handleChangeVariantStock;
    $[60] = hasStock;
    $[61] = t;
    $[62] = variant.deleted;
    $[63] = variant.stock;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  let t26;
  if ($[65] !== t11 || $[66] !== t14 || $[67] !== t19 || $[68] !== t24 || $[69] !== t25 || $[70] !== t7 || $[71] !== t9) {
    t26 = <div className={t7}>{t9}{t11}{t14}{t19}{t24}{t25}</div>;
    $[65] = t11;
    $[66] = t14;
    $[67] = t19;
    $[68] = t24;
    $[69] = t25;
    $[70] = t7;
    $[71] = t9;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  let t27;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <hr className="border-text-secondary -ml-6 -mr-6 mb-2 mt-2 border-t-[1.5px] border-solid opacity-40" />;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  let t28;
  if ($[74] !== t26) {
    t28 = <>{t26}{t27}</>;
    $[74] = t26;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  return t28;
}
function _temp(e_0) {
  return e_0.value;
}
export default Variant;